import {
  SoilInfoSection,
  SoilDetailSection,
  FieldSoilSection,
  Text,
  DividerText,
  HectareText,
  SoilColor,
} from './PropertySoilInfo.styles';
import { useTranslation } from 'react-i18next';
import { SoilPopData } from '../SoilCharacteristics';

interface Field {
  data?: SoilPopData[];
}

const formatNumber = (num: number) => num.toFixed(2);

const PropertySoilInfo = ({ data }: Field): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      {data?.map((item) => (
        <SoilInfoSection key={item.name}>
          <FieldSoilSection>
            <SoilColor color={item.color} />
          </FieldSoilSection>
          <SoilDetailSection>
            <Text>{item.name}</Text>
            <DividerText>|</DividerText>
            <HectareText>{`${formatNumber(item.size)} ${t('ha')}`}</HectareText>
          </SoilDetailSection>
        </SoilInfoSection>
      ))}
    </>
  );
};

export default PropertySoilInfo;
